import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { UtilsModule } from '../../utils/utils.module';
@Component({
  selector: 'nf-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.css']
})
export class TimerComponent implements OnInit {

  visible = false;
  offset = 1;
  count = 1;
  rangeList = [
    {
      'value': -1,
      'title': '之前'
    },
    {
      'value': 1,
      'title': '之后'
    }
  ];
  dateTypes = [
    {
      value: 'workdays',
      title: '工作日'
    },
    {
      value: 'days',
      title: '自然日'
    }
  ];
  schedulerConfig = {
    type: 'daily',
    occurrences: 1,
    unit: 'days',
    time: '',
    hourStart: '',
    hourEnd: '',
    dateType: 'days',
    minutesInterval: 1,
    offset: {
      count: 1,
      unit: 'days'
    },
    TDayConfig: {
      type: 'daily',
      offset: {
        count: 1,
        unit: 'days',
      },
      description: 'T'
    },
    description: ''
  };
  time = new Date();
  hourStart = new Date();
  hourEnd = new Date();
  @Input('nfData') set ChangeData(data: any) {
    if (data) {
      this.schedulerConfig = data;
      if (this.schedulerConfig.time) {
        const times = this.schedulerConfig.time.split(':');
        this.time.setHours(parseInt(times[0]));
        this.time.setMinutes(parseInt(times[1]));
        this.time.setSeconds(parseInt(times[2]));
      }
      if (this.schedulerConfig.hourStart) {
        this.hourStart.setHours(Number(this.schedulerConfig.hourStart));
      }
      if (this.schedulerConfig.hourEnd) {
        this.hourEnd.setHours(Number(this.schedulerConfig.hourEnd));
      }
      if (this.schedulerConfig.offset) {
        const offset = this.schedulerConfig.offset;
        if (offset.count >= 0) {
          this.offset = 1;
          this.count = offset.count;
        } else {
          this.offset = -1;
          this.count = -offset.count;
        }
      }
      this.typeChange();
    }
  }
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeTimer: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private utilsModule: UtilsModule
  ) { }

  ngOnInit() {
    this.typeChange();
  }
  // 定时任务组件-radio切换
  timerRadioChange() {
    this.schedulerConfig.occurrences = 1;
    this.schedulerConfig.offset.unit = 'days';
    switch (this.schedulerConfig.type) {
      case 'daily':
        this.schedulerConfig.unit = 'days';
        break;
      case 'monthly':
        this.setTDayConfig('monthly');
        break;
      case 'quarter':
        this.count = 5;
        this.schedulerConfig.offset.count = 5;
        this.setTDayConfig('quarter');
        break;
      case 'annual':
        this.count = 1;
        this.schedulerConfig.offset.count = 1;
        this.setTDayConfig('annual');
        break;
      case 'minutes':
        this.schedulerConfig.dateType = 'days';
        break;
    }
    this.typeChange();
  }

  setTDayConfig(type) {
    this.schedulerConfig.TDayConfig = {
      type: type,
      offset: {
        count: -1,
        unit: 'days'
      },
      description: 'T'
    };
  }

  typeChange() {
    switch (this.schedulerConfig.type) {
      case 'daily':
        this.dailyChange();
        break;
      case 'monthly':
        this.monthlyChange();
        break;
      case 'quarter':
        this.seasonChange();
        break;
      case 'annual':
        this.yearChange();
        break;
      case 'minutes':
        this.minutesChange();
        break;
    }
  }

  // 定时任务组件-每日选择回调
  dailyChange() {
    this.schedulerConfig.description = '每 ' + this.schedulerConfig.occurrences + ' 个 ' +
      this.getSelectTitle(this.dateTypes, this.schedulerConfig.unit) + ' 的 '
      + this.utilsModule.formatTimeByGeneral(this.time);
    this.schedulerConfig.time = this.utilsModule.formatTimeByGeneral(this.time);
  }

  monthlyChange() {
    this.schedulerConfig.description = '每月的 T ' + this.getSelectTitle(this.rangeList, this.offset) + ' '
      + this.count + ' 个 ' + this.getSelectTitle(this.dateTypes, this.schedulerConfig.offset.unit)
      + ' 的 ' + this.utilsModule.formatTimeByGeneral(this.time);
    this.schedulerConfig.time = this.utilsModule.formatTimeByGeneral(this.time);
  }

  seasonChange() {
    this.schedulerConfig.description = '每季度的 T ' + this.getSelectTitle(this.rangeList, this.offset) + ' '
      + this.count + ' 个 ' + this.getSelectTitle(this.dateTypes, this.schedulerConfig.offset.unit)
      + ' 的 ' + this.utilsModule.formatTimeByGeneral(this.time);
    this.schedulerConfig.time = this.utilsModule.formatTimeByGeneral(this.time);
  }

  yearChange() {
    this.schedulerConfig.description = '每年的 T ' + this.getSelectTitle(this.rangeList, this.offset)
      + ' 的 ' + this.count + ' 个 ' + this.getSelectTitle(this.dateTypes, this.schedulerConfig.offset.unit)
      + ' 的 ' + this.utilsModule.formatTimeByGeneral(this.time);
    this.schedulerConfig.time = this.utilsModule.formatTimeByGeneral(this.time);
  }
  minutesChange() {
    this.schedulerConfig.description = '每' + this.schedulerConfig.occurrences + ' 个 ' + this.getSelectTitle(this.dateTypes, this.schedulerConfig.dateType) + ' 的 ' + this.utilsModule.formatHoursByGeneral(this.hourStart) + '时至' + this.utilsModule.formatHoursByGeneral(this.hourEnd) + '时 每隔' + this.schedulerConfig.minutesInterval + '分钟';
    this.schedulerConfig.hourStart = this.utilsModule.formatHoursByGeneral(this.hourStart);
    this.schedulerConfig.hourEnd = this.utilsModule.formatHoursByGeneral(this.hourEnd);
  }
  monthOffsetChange() {
    this.schedulerConfig.offset.count = this.offset * this.count;
    this.monthlyChange();
  }

  monthCountChange() {
    this.schedulerConfig.offset.count = this.offset * this.count;
    this.monthlyChange();
  }

  seasonOffsetChange() {
    this.schedulerConfig.offset.count = this.offset * this.count;
    this.seasonChange();
  }

  seasonCountChange() {
    this.schedulerConfig.offset.count = this.offset * this.count;
    this.seasonChange();
  }

  yearOffsetChange() {
    this.schedulerConfig.offset.count = this.offset * this.count;
    this.yearChange();
  }

  yearCountChange() {
    this.schedulerConfig.offset.count = this.offset * this.count;
    this.yearChange();
  }

  // 获取下拉选项的表述
  getSelectTitle(target: Array<any>, value): string {
    if (target && target.length > 0) {
      for (let item of target) {
        if (item.value === value) {
          return item.title;
        }
      }
      return '';
    } else {
      return '';
    }
  }

  getTDayConfig(data) {
    this.schedulerConfig.TDayConfig = data;
  }

  // 关闭t-day pop
  closeTDay() {
    this.visible = false;
  }

  // 确定提交
  timerOnSubmit() {
    this.nfDataChange.emit(this.schedulerConfig);
    this.closeTimer.emit();
  }
}
